import { render } from "./Mfa.vue?vue&type=template&id=e0603fa4"
import script from "./Mfa.vue?vue&type=script&lang=js"
export * from "./Mfa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__